import { QueryClientProvider } from "@tanstack/react-query";

import { Toaster } from "@/core/notifications";
import { Routes } from "@/core/routing";
import { queryClient, ReactQueryDevTools } from "@core/caching";
import { FFlagProvider } from "@core/featureFlags";

import "react-datasheet-grid/dist/style.css";
import "@/styles/index.css";

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <FFlagProvider>
        <Routes />
        <Toaster position="bottom-right" />
      </FFlagProvider>
      <ReactQueryDevTools />
    </QueryClientProvider>
  );
};
